/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIdentifiedClientRefRequest
 */
export interface UpdateIdentifiedClientRefRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateIdentifiedClientRefRequest
     */
    identityId?: string;
}

/**
 * Check if a given object implements the UpdateIdentifiedClientRefRequest interface.
 */
export function instanceOfUpdateIdentifiedClientRefRequest(value: object): value is UpdateIdentifiedClientRefRequest {
    return true;
}

export function UpdateIdentifiedClientRefRequestFromJSON(json: any): UpdateIdentifiedClientRefRequest {
    return UpdateIdentifiedClientRefRequestFromJSONTyped(json, false);
}

export function UpdateIdentifiedClientRefRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIdentifiedClientRefRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
    };
}

export function UpdateIdentifiedClientRefRequestToJSON(value?: UpdateIdentifiedClientRefRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
    };
}

